// src/pages/ResumePage.jsx

const ResumePage = () => {
  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 text-gray-900 dark:text-gray-100 flex flex-col">

      <header className="w-full bg-gray-50 dark:bg-gray-900 border-b border-gray-200/60 dark:border-gray-700/60 py-6 text-center">
        <h1 className="text-2xl sm:text-3xl md:text-4xl font-semibold text-gray-900 dark:text-white">
          Resume
        </h1>
        <p className="text-sm sm:text-base text-gray-600 dark:text-gray-300 mt-1">
          My Resume
        </p>
      </header>

      {/* Iframe for Google Drive preview */}
      <main className="flex-1 flex justify-center items-start mt-6 px-4 sm:px-6 lg:px-8 pb-10">
        <iframe
          src="https://drive.google.com/file/d/1Bv8vVQKd-i6tydr-rPo-tWMXWFoUkSmf/preview"
          className="w-full max-w-4xl h-[75vh] sm:h-[80vh] md:h-[85vh] rounded-xl shadow-lg"
          style={{ border: "none", backgroundColor: "transparent" }}
          allow="autoplay"
          title="Resume Preview"
        ></iframe>
      </main>
    </div>
  );
};

export default ResumePage;
